import {Tag, TagLabel, TagLeftIcon} from '@chakra-ui/react'
import {CheckCircleIcon} from '@chakra-ui/icons'
import {useTranslation} from 'react-i18next'
import {useRails} from '~/react/contexts/rails'

export const AccountingProviderSyncTag = () => {
  const {t} = useTranslation('pointsOnPayments')
  const {accountingProvider} = useRails()
  const providerName = accountingProvider?.name

  if (!providerName) {
    return null
  }

  return (
    <Tag variant="status" colorScheme="success">
      <TagLeftIcon as={CheckCircleIcon} color="mld.success.700" />
      <TagLabel textTransform="uppercase">
        {t('accountingProviderSyncTag.label', {providerName})}
      </TagLabel>
    </Tag>
  )
}

export default AccountingProviderSyncTag
